'use strict';

class Dropbox {
  constructor($http, $window) {
    this.$http = $http;
    this.$window = $window;
  }

  $onInit() {
    this.linked = false;

    this.$http.get('/originators/current/dropbox/link/valid')
      .then((resp) => {
        this.linked = resp.data.isValid;
      });
  }

  link() {
    this.$http.post('/originators/current/dropbox/link')
      .then((resp) => {
        this.$window.location.href = resp.data.redirectUrl;
      });
  }

  unlink() {
    this.$http.post('/originators/current/dropbox/unlink')
      .then(() => {
        this.linked = false;
      });
  }
}

Dropbox.$inject = ['$http', '$window'];

const dropbox = {
  controller: Dropbox,
  template: `
    <h3 class="subheader">Dropbox</h3>

    <fieldset>
      <div class="row" ng-class="{ linked: $ctrl.linked, unlinked: !$ctrl.linked }">
        <div class="alert-box success" ng-if="$ctrl.linked">Kontoen din er koblet til Dropbox</div>

        <div class="large-3 columns">
          <img src="/assets/img/dropbox.png" alt="Koble SendRegning til Dropbox-kontoen min" />
        </div>

        <div class="large-9 columns">
          <div ng-if="!$ctrl.linked">
            <p>
              SendRegning kan laste opp kopier av alle regninger du sender til din Dropbox-konto.
              For å bruke denne funksjonen må du koble din Dropbox-konto til din SendRegning-konto.
              Når du gjør dette vil det opprettes en ny underkatalog i Dropbox som heter Apps/SendRegning.
            </p>
            <p>SendRegning vil bare få tilgang til innholdet i underkatalogen 'SendRegning'. Alt annet du lagrer, eller har lagret tidligere, vil IKKE SendRegning ha tilgang til.</p>
            <a href ng-click="$ctrl.link()" class="button">Koble SendRegning til Dropbox-kontoen min <i class="fa fa-external-link"></i></a>
          </div>
          <div ng-if="$ctrl.linked">
            <p>
              Det er enkelt å koble din SendRegning-konto fra Dropbox hvis du ønsker det.
              Trykk på knappen under, og SendRegning vil slutte å laste opp kopier.
              Vil du fjerne det du allerede har lastet opp, må du avinstallere SendRegning-appen i
              <a href="https://www.dropbox.com/account#newsecurity" target="_blank">Dropbox</a>.
            </p>
            <a href ng-click="$ctrl.unlink()" class="button secondary">Koble SendRegning fra Dropbox-kontoen min</a>
          </div>
        </div>
      </div>
    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('dropbox', dropbox);
